/**
 * Created by Vladislav on 26.02.2026.
 */

const VictoryWindowRewards = cleverapps.Layout.extend({
    ctor: function () {
        this.rewards = new RewardsList(Game.currentGame.rewards, {
            event: Game.currentGame.level.isBonus() ? cleverapps.EVENTS.EARN.BONUS_LEVEL_REWARD : cleverapps.EVENTS.EARN.LEVEL_COMPLETE,
            withoutSidebar: cleverapps.resolution.isVertical()
        });

        this.rewards.receiveRewards();
        cleverapps.dataLoader.processSaveQueue();

        this.rewardsList = this.createRewardsList();

        const items = [this.rewardsList];

        if (Game.currentGame.needBonusReward()) {
            this.bonusChest = new BonusLevelComponent(Game.currentGame.bonusLevelCounter.getCoins());
            items.push(this.bonusChest);
        }

        this._super(items, {
            margin: cleverapps.styles.VictoryWindow.margin,
            direction: cleverapps.UI.VERTICAL
        });

        this.setLocalZOrder(WindowComponent.WINDOWS_ZORDER);
        SceneComponent.retainBetweenScenes(this);
    },

    showUp: function (callback, options) {
        this.rewardsList.showUp(callback, options);

        if (this.bonusChest) {
            this.bonusChest.showUp();
        }
    },

    receiveRewards: function (f) {
        this.received = true;

        this.runAction(
            new cc.Spawn(
                new cc.DelayTime(2),
                this.rewardsList.receiveRewardsAction({
                    spawnHaptic: "reward.spawn",
                    landHaptic: "reward.land",
                    collectHaptic: "reward.collect"
                })
            )
        ).setFinalize(f);

        if (this.bonusChest) {
            this.bonusChest.receiveRewards(() => {});
        }
    },

    isReceived: function () {
        return !!this.received;
    },

    createRewardsList: function () {
        const styles = cleverapps.styles.VictoryWindow.rewards;

        const columns = cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL ? 3 : 5;
        return new RewardsListComponent(this.rewards, {
            columns,
            iconWrap: styles.iconWrap,
            textMargin: styles.textMargin,
            font: cleverapps.styles.FONTS.REWARDWINDOW_VALUE_TEXT,
            noShowControls: true,
            event: cleverapps.EVENTS.EARN.LEVEL_COMPLETE,
            shine: styles.shine,
            filterCustomAnimation: true
        });
    }
});